import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import Loading from 'bisu-react-loading'

import { fetchReport } from 'containers/Reports/Collections/actions'

import Data from './data'

class Collections extends Component {

  constructor(props) {
    super(props)
    this.state = {
      data: fromJS({}),
    }
  }

  componentDidMount() {
    const { query } = this.props.location
    const payload = fromJS({
      by: query.by,
      date_from: query.date_from,
      date_to: query.date_to,
      or_from: query.or_from,
      or_to: query.or_to,
      fund: query.fund,
      cashier_id: query.cashier_id,
    })
    this.props.dispatch(fetchReport(payload))
      .then((res) => {
        if (!res.error) {
          this.setState({
            data: fromJS(res.payload || {}),
          })
        }
      })
  }

  render() {
    const { data } = this.state
    const { __campus } = this.props

    if (data.size === 0) {
      return <Loading />
    }

    return <Data data={data} campus={__campus} />
  }
}

Collections.propTypes = {
  __campus: PropTypes.string,
}

function mapStateToProps(state) {
  return {
    __campus: state.auth.getIn(['session', 'campus']),
  }
}

export default connect(mapStateToProps)(Collections)



// WEBPACK FOOTER //
// ./src/containers/Print/Reports/Collections/index.js